import 'driver.js/dist/driver.min.css'
import Driver from 'driver.js'

const disableContractSelect = () => {
  const el = document.getElementById('select-contract')
  if (el) el.disabled = true
}

const enableContractSelect = () => {
  const el = document.getElementById('select-contract')
  if (el) el.disabled = false
}

export const initContractsTour = () => {
  if (!document.getElementById('start-tour') && !document.getElementById('start-tour-modal')) return

  const driver = window.driver || new Driver({

    className: 'tour-popup',
    allowClose: false,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    opacity: 0,
    onReset: () => enableContractSelect()
  })

  const primarySteps = [
    {
      element: '#select-contract',
      popover: {
        title: '📃 Select Contract',
        description:
          'Here you can select from a list of contracts on this Contract Vehicle and view performance data for the suppliers on those contracts.',
        position: 'right'
      }
    },
    {
      element: '#contract-table-name-header',
      popover: {
        title: '📋 Contract-Specific Data',
        description: 'Aside from the "National Rating and Count" column, all data you see on this table is based ONLY on feedback we\'ve collected from buyers in your state. <a href="/resources/47" target="_blank">Learn more</a> about Procurated ratings.',
        position: 'top-center'
      }
    },
    {
      element: '.supplier-index-listing:first-of-type > .supplier-name',
      popover: {
        title: '🚚 View Details',
        description:
          'Click on any row in the table to view detailed reviews for each supplier, including ratings data aggregated by contributing government organizations.',
        position: 'right'
      }
    },
    {
      element: '#start-tour',
      popover: {
        title: 'ℹ️ Restart Tour',
        description: 'Click here to restart the step by step tour at anytime.',
        position: 'left'
      }
    }
  ].filter(step => document.querySelector(step.element))

  driver.defineSteps(primarySteps)
  window.driver = driver

  $(document).off('click.contractTour')
  $(document).on('click.contractTour', '#start-tour, #start-tour-modal', function (e) {
    e.preventDefault()
    e.stopPropagation()
    disableContractSelect()
    driver.start(0)
  })
}
